import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import {
  domaineOptions,
  registerNationalityOptions,
} from '../../../../shared/utils/data/etablissments-data';
import { FlagType, userType } from '../../../../shared/utils/enums';
import { AuthService } from '../../../../services/auth.service';
import { EstablishmentService } from '../../../../services/establishment.service';
import { CandidatService } from '../../../../services/candidat.service';
import { MissionService } from '../../../../services/mission.service';
import { PhoneNumberFormat } from '@justin-s/ngx-intl-tel-input';
import { FlagService } from '../../../../shared/services/flag.service';
import { Router } from '@angular/router';
import moment from 'moment';

@Component({
  selector: 'app-third-step-candidat',
  templateUrl: './third-step-candidat.component.html',
  styleUrl: './third-step-candidat.component.scss',
})
export class ThirdStepCandidatComponent {
  @Input() form: FormGroup;
  @Input() firstStepForm: FormGroup;
  @Input() loading: boolean;
  @Output() onSubmit = new EventEmitter<any>();
  image: string;
  loadingSecurity = false;
  loadingDocuments = false;
  isCondidat: boolean = false;
  userId: any;
  candidatBody: any;
  domaineOptions: any[];
  fonctionOptions: any[];
  PhoneNumberFormat = PhoneNumberFormat;
  birthDay: string;
  graduationYear: string;
  documentForm = this.fb.group({
    idFace: [undefined],
    idBack: [undefined],
    passport: [undefined],
  });
  identityCartOpt = [
    { id: 1, name: 'Carte d’identité' },
    { id: 2, name: 'Passeport' },
  ];
  justificatifDomicileOptn = [
    { id: 2, name: 'Vous avez un justiﬁcatif de domicile à votre nom' },
    {
      id: 1,
      name: `Vous êtes hébergé par une autre personne`,
    },
  ];
  justificatifDomicileOptn2 = [
    { id: 1, name: 'Facture de téléphone', fromData: 'phoneBill' },

    {
      id: 2,
      name: `Facture d'électricité ou de gaz`,
      fromData: 'electroBill',
    },
    {
      id: 3,
      name: `Quittance de loyer émanant d'un organisme social ou d'une agence immobilière`,
      fromData: 'quittanceImmob',
    },
    {
      id: 4,
      name: `Titre de propriété`,
      fromData: 'propertyTitle',
    },
    {
      id: 5,
      name: `Facture d'eau`,
      fromData: 'waterBill',
    },
    {
      id: 6,
      name: `Avis d’imposition ou certification de non imposition`,
      fromData: 'certImpos',
    },
    {
      id: 7,
      name: `Justificatif de taxe d’habitation ou de taxe foncière`,
      fromData: 'taxBill',
    },
    {
      id: 8,
      name: `Attestation ou facture d'assurance du logement`,
      fromData: 'assuranceLogement',
    },
  ];
  pdfLists = [
    {
      id: 1,
      name: 'idFace',
      fileName: 'CvRecto',
    },
    {
      id: 1,
      name: 'sejourFace',
      fileName: 'sejourFace',
    },
    {
      id: 1,
      name: 'sejourBack',
      fileName: 'sejourBack',
    },
    {
      id: 1,
      name: 'idBack',
      fileName: 'CvVerso',
    },
    {
      id: 1,
      name: 'bankDetails',
      fileName: 'bankDetails',
    },
    {
      id: 1,
      name: 'passport',
      fileName: 'passport',
    },
    {
      id: 1,
      name: 'socialSecurityCertif',
      fileName: 'socialSecurity',
    },
    {
      id: 1,
      name: 'letterSignedByHost',
      fileName: 'letterSigned',
    },
    {
      id: 1,
      name: 'justificatifDomicileHost',
      fileName: 'Host',
    },
    {
      id: 1,
      name: 'justificatifDomicile',
      fileName: 'justificatifDomicile',
    },
    {
      id: 1,
      name: 'phoneBill',
      fileName: 'phoneBill',
    },
    {
      id: 1,
      name: 'electroBill',
      fileName: 'electroBill',
    },
    {
      id: 1,
      name: 'carteGrise',
      fileName: 'carteGrise',
    },
    {
      id: 1,
      name: 'insuranceResponsibility',
      fileName: 'insuranceResponsibility',
    },
    {
      id: 1,
      name: 'enrollmentCertificate',
      fileName: 'enrollmentCertificate',
    },
    {
      id: 1,
      name: 'quittanceImmob',
      fileName: 'quittanceImmob',
    },
    {
      id: 1,
      name: 'propertyTitle',
      fileName: 'propertyTitle',
    },
    {
      id: 1,
      name: 'waterBill',
      fileName: 'waterBill',
    },
    {
      id: 1,
      name: 'certImpos',
      fileName: 'certImpos',
    },
    {
      id: 1,
      name: 'taxBill',
      fileName: 'taxBill',
    },
    {
      id: 1,
      name: 'assuranceLogement',
      fileName: 'assuranceLogement',
    },
    {
      id: 1,
      name: 'cv',
      fileName: 'cvFile',
    },
    {
      id: 1,
      name: 'firstDiplome',
      fileName: 'Dipolome',
    },
    {
      id: 1,
      name: 'secondDiplome',
      fileName: 'Dipolome1',
    },
    {
      id: 1,
      name: 'thirdDiplome',
      fileName: 'Dipolome2',
    },
  ];
  user: any;
  identityCart = new FormGroup({
    value: new FormControl(1),
  });
  justificatifDomicile = new FormGroup({
    value: new FormControl(2),
  });
  justificatifDomicile2 = new FormGroup({
    value: new FormControl(1),
  });
   documentFormGroup: FormGroup = this.fb.group({
    idFace: [],
    idBack: [],
    sejourFace: [],
    sejourBack: [],
    passport: [],
    bankDetails: [],
    socialSecurityCertif: [],
    letterSignedByHost: [],
    justificatifDomicileHost: [],
    justificatifDomicile: [],
    phoneBill: [],
    electroBill: [],
    quittanceImmob: [],
    propertyTitle: [],
    waterBill: [],
    certImpos: [],
    taxBill: [],
    assuranceLogement: [],
    cv: ['', Validators.required],
    firstDiplome: ['', Validators.required],
    secondDiplome: [],
    thirdDiplome: [],
  });
  phoneForm = new FormGroup({
    phone: new FormControl({
      countryCode: '',
      dialCode: '',
      e164Number: '',
      internationalNumber: '',
      nationalNumber: '',
      number: '',
    }),
  });
  file: any[] = [];

  formSecurity: FormGroup = this.fb.group({
    password: [''],
    confirmPassword: [''],
    newPassword: [''],
  });
  formData = new FormData();
  constructor(
    public auth: AuthService,
    private fb: FormBuilder,
    public establishmentService: EstablishmentService,
    private condidatApi: CandidatService,
    private missionApi: MissionService,
    private flag: FlagService,
    private router: Router
  ) {
    this.user = localStorage.getItem('user')
      ? JSON.parse(localStorage.getItem('user') || '')
      : {};
    
    if (this.identityCart.get('value')?.value == 1) {
      this.documentFormGroup.controls['idFace'].setValidators([
        Validators.required,
      ]);
      this.documentFormGroup.controls['idBack'].setValidators([
        Validators.required,
      ]);
      this.documentFormGroup.controls['passport'].clearValidators();
    } else {
      this.documentFormGroup.controls['passport'].setValidators([
        Validators.required,
      ]);
        this.documentFormGroup.controls['idFace'].clearValidators();
      this.documentFormGroup.controls['idBack'].clearValidators();
       
    }

    if (this.justificatifDomicile.get('value')?.value == 1) {
       this.documentFormGroup.controls['phoneBill'].setValidators([
       ]);
       this.documentFormGroup.controls['electroBill'].setValidators([
       ]);
       this.documentFormGroup.controls['quittanceImmob'].setValidators([
       ]);
      this.documentFormGroup.controls['propertyTitle'].setValidators([
      ]);
   
          this.documentFormGroup.controls['waterBill'].setValidators([
          ]);
          this.documentFormGroup.controls['certImpos'].setValidators([
          ]);
          this.documentFormGroup.controls['taxBill'].setValidators([
          ]);
          this.documentFormGroup.controls['assuranceLogement'].setValidators([
          ]);
          this.documentFormGroup.controls['letterSignedByHost'].setValidators([
            Validators.required,
          ]);
          this.documentFormGroup.controls['justificatifDomicileHost'].setValidators(
            [Validators.required]
          );
          this.documentFormGroup.controls['justificatifDomicile'].setValidators([
            Validators.required,
          ]);
    } else {
      switch (this.justificatifDomicile2.get('value')?.value) {
        case 1:
          this.documentFormGroup.controls['phoneBill'].setValidators([
            Validators.required,
          ]);
          break;
        case 2:
          this.documentFormGroup.controls['electroBill'].setValidators([
            Validators.required,
          ]);
          break;
        case 3:
          this.documentFormGroup.controls['quittanceImmob'].setValidators([
            Validators.required,
          ]);
          break;
        case 4:
          this.documentFormGroup.controls['propertyTitle'].setValidators([
            Validators.required,
          ]);
          break;
        case 5:
          this.documentFormGroup.controls['waterBill'].setValidators([
            Validators.required,
          ]);
          break;
        case 6:
          this.documentFormGroup.controls['certImpos'].setValidators([
            Validators.required,
          ]);
          break;
        case 7:
          this.documentFormGroup.controls['taxBill'].setValidators([
            Validators.required,
          ]);
          break;
        case 8:
          this.documentFormGroup.controls['assuranceLogement'].setValidators([
            Validators.required,
          ]);
          break;
        default:
          this.documentFormGroup.controls['phoneBill'].setValidators([
            Validators.required,
          ]);
          break;
      }
    }

    this.documentFormGroup.controls['idBack'].updateValueAndValidity();
    this.documentFormGroup.controls['idFace'].updateValueAndValidity();
    this.documentFormGroup.controls['passport'].updateValueAndValidity();
    this.documentFormGroup.controls['letterSignedByHost'].updateValueAndValidity();
    this.documentFormGroup.controls['justificatifDomicileHost'].updateValueAndValidity();
    this.documentFormGroup.controls['justificatifDomicile'].updateValueAndValidity();
    this.documentFormGroup.controls['phoneBill'].updateValueAndValidity();
    this.documentFormGroup.controls['electroBill'].updateValueAndValidity();
    this.documentFormGroup.controls['quittanceImmob'].updateValueAndValidity();
    this.documentFormGroup.controls['propertyTitle'].updateValueAndValidity();
    this.documentFormGroup.controls['waterBill'].updateValueAndValidity();
    this.documentFormGroup.controls['certImpos'].updateValueAndValidity();
    this.documentFormGroup.controls['taxBill'].updateValueAndValidity();
    this.documentFormGroup.controls['assuranceLogement'].updateValueAndValidity();
  }

  ngOnInit(): void {
    this.user = localStorage.getItem('user')
      ? JSON.parse(localStorage.getItem('user') || '')
      : {};
    this.form.get('email')?.patchValue(this.auth.user?.email);
    this.form.get('email')?.disable();
    if (
      this.firstStepForm.get('worktype')?.value &&
      (this.firstStepForm.get('worktype')?.value == 1 ||
        this.firstStepForm.get('worktype')?.value == 7 ||
        this.firstStepForm.get('worktype')?.value == 11)
    ) {
     /* this.documentFormGroup.controls['secondDiplome'].setValidators([
        Validators.required,
      ]);
      this.documentFormGroup.controls['secondDiplome'].updateValueAndValidity();*/
    }

    if (this.form.get('nationality')?.value != 'autre') {
      if (this.identityCart.get('value')?.value == 1) {
          this.documentFormGroup.controls['idFace'].setValidators([
            Validators.required,
          ]);
          this.documentFormGroup.controls['idBack'].setValidators([
            Validators.required,
          ]);
          
          this.documentFormGroup.controls['passport'].clearValidators();
           this.documentFormGroup.controls['passport'].setValidators([
           
          ]);
        } else {
          this.documentFormGroup.controls['passport'].setValidators([
            Validators.required,
          ]);
          this.documentFormGroup.controls['idFace'].clearValidators();
          this.documentFormGroup.controls['idBack'].clearValidators();
          this.documentFormGroup.controls['idFace'].setValidators([
           
          ]);
           this.documentFormGroup.controls['idBack'].setValidators([
           
          ]);
        }
      }
      else {
        this.documentFormGroup.controls['idFace'].setValidators([]);
        this.documentFormGroup.controls['idBack'].setValidators([]);

        this.documentFormGroup.controls['passport'].setValidators([
          Validators.required,
        ]);
        this.documentFormGroup.controls['sejourFace'].setValidators([
          Validators.required,
        ]);
        this.documentFormGroup.controls['sejourBack'].setValidators([
          Validators.required,
        ]);
        this.documentFormGroup.controls['sejourFace'].setValidators([
          Validators.required,
        ]);
        this.documentFormGroup.controls['sejourBack'].setValidators([
          Validators.required,
        ]);
    }
    
        let count = 0;
        this.form.controls['nationality'].valueChanges.subscribe((el: any) => {
          
          count += 1;
          if (count > 1) {
            this.candidatBody.passport = '';
            this.candidatBody.idFace = '';
            this.candidatBody.idBack = '';
            this.candidatBody.idBackUrl = '';
            this.candidatBody.idFaceUrl = '';
            this.candidatBody.passportUrl = '';
            this.candidatBody.sejourFace = '';
            this.candidatBody.sejourFaceUrl = '';
            this.candidatBody.sejourBack = '';
            this.candidatBody.sejourBackUrl = '';
          }
          if (el == 'autre') {
              this.documentFormGroup.controls['idFace'].clearValidators();
              this.documentFormGroup.controls['idBack'].clearValidators();
              this.documentFormGroup.controls['idFace'].setValidators([])
              this.documentFormGroup.controls['idBack'].setValidators([]);
              this.documentFormGroup.controls['passport'].setValidators([
                Validators.required,
              ]);
              this.documentFormGroup.controls['sejourFace'].setValidators([
                Validators.required,
              ]);
              this.documentFormGroup.controls['sejourBack'].setValidators([
                Validators.required,
              ]);
            }  else {
              this.documentFormGroup.controls['sejourBack'].clearValidators();
              this.documentFormGroup.controls['sejourFace'].clearValidators();
              this.documentFormGroup.controls['passport'].clearValidators();
              this.documentFormGroup.controls['sejourBack'].setValidators([])
              this.documentFormGroup.controls['sejourFace'].setValidators([]);
              this.documentFormGroup.controls['passport'].setValidators([]);
              this.documentFormGroup.controls['idFace'].setValidators([Validators.required]);
              this.documentFormGroup.controls['idBack'].setValidators([Validators.required]);
              
              if (this.identityCart.get('value')?.value == 2) {
                this.documentFormGroup.controls['idFace'].setValidators([]);
                this.documentFormGroup.controls['idBack'].setValidators([]);
                this.documentFormGroup.controls['passport'].setValidators([Validators.required]);
              }
            }
            this.documentFormGroup.controls['idBack'].updateValueAndValidity();
            this.documentFormGroup.controls['idFace'].updateValueAndValidity();
            this.documentFormGroup.controls['passport'].updateValueAndValidity();
            this.documentFormGroup.controls['sejourFace'].updateValueAndValidity();
            this.documentFormGroup.controls['sejourBack'].updateValueAndValidity();
        });
        
    if (this.justificatifDomicile.get('value')?.value == 1) {
        this.documentFormGroup.controls['phoneBill'].setValidators([]);
        this.documentFormGroup.controls['electroBill'].setValidators([]);
        this.documentFormGroup.controls['quittanceImmob'].setValidators([]);
        this.documentFormGroup.controls['propertyTitle'].setValidators([]);
        this.documentFormGroup.controls['waterBill'].setValidators([]);
        this.documentFormGroup.controls['certImpos'].setValidators([]);
        this.documentFormGroup.controls['taxBill'].setValidators([]);
        this.documentFormGroup.controls['assuranceLogement'].setValidators([]);
        this.documentFormGroup.controls['letterSignedByHost'].setValidators([Validators.required]);
        this.documentFormGroup.controls['justificatifDomicileHost'].setValidators([Validators.required]);
        this.documentFormGroup.controls['justificatifDomicile'].setValidators([Validators.required]);
      }
      else {
        switch (this.justificatifDomicile2.get('value')?.value) {
          case 1:
            this.documentFormGroup.controls['phoneBill'].setValidators([Validators.required]);
            break;
          case 2:
            this.documentFormGroup.controls['electroBill'].setValidators([Validators.required]);
            break;
          case 3:
            this.documentFormGroup.controls['quittanceImmob'].setValidators([Validators.required]);
            break;
          case 4:
            this.documentFormGroup.controls['propertyTitle'].setValidators([Validators.required]);
            break;
          case 5:
            this.documentFormGroup.controls['waterBill'].setValidators([Validators.required]);
            break;
          case 6:
            this.documentFormGroup.controls['certImpos'].setValidators([Validators.required]);
            break;
          case 7:
            this.documentFormGroup.controls['taxBill'].setValidators([Validators.required]);
            break;
          case 8:
            this.documentFormGroup.controls['assuranceLogement'].setValidators([Validators.required]);
            break;
          default:
            this.documentFormGroup.controls['phoneBill'].setValidators([Validators.required]);
            break;
        }
    }
    
     this.identityCart.valueChanges.subscribe(({ value }) => {
        if (value == 1) {
          this.documentFormGroup.controls['passport'].clearValidators();
          this.documentFormGroup.controls['passport'].setValidators([]);
          this.documentFormGroup.controls['idFace'].setValidators([
            Validators.required,
          ]);
          this.documentFormGroup.controls['idBack'].setValidators([
            Validators.required,
          ]);
        } else {
            this.documentFormGroup.controls['idFace'].clearValidators();
            this.documentFormGroup.controls['idBack'].clearValidators();
            this.documentFormGroup.controls['idFace'].setValidators([]);
            this.documentFormGroup.controls['idBack'].setValidators([]);
            this.documentFormGroup.controls['passport'].setValidators([
              Validators.required,
            ]);
        }
    this.documentFormGroup.controls['phoneBill'].updateValueAndValidity();
    this.documentFormGroup.controls['electroBill'].updateValueAndValidity();
    this.documentFormGroup.controls['quittanceImmob'].updateValueAndValidity();
    this.documentFormGroup.controls['propertyTitle'].updateValueAndValidity();
    this.documentFormGroup.controls['waterBill'].updateValueAndValidity();
    this.documentFormGroup.controls['certImpos'].updateValueAndValidity();
    this.documentFormGroup.controls['taxBill'].updateValueAndValidity();
    this.documentFormGroup.controls['passport'].updateValueAndValidity();

    this.documentFormGroup.controls['sejourFace'].updateValueAndValidity();
    this.documentFormGroup.controls['sejourBack'].updateValueAndValidity();
    
    this.documentFormGroup.controls['idFace'].updateValueAndValidity();
    this.documentFormGroup.controls['idBack'].updateValueAndValidity();
    this.documentFormGroup.controls['assuranceLogement'].updateValueAndValidity();
    this.documentFormGroup.controls['phoneBill'].updateValueAndValidity();
        
      });
      
     this.justificatifDomicile.valueChanges.subscribe(({ value }) => {
        if (value == 1) {
          this.documentFormGroup.controls['phoneBill'].setValidators([]);
          this.documentFormGroup.controls['electroBill'].setValidators([]);
          this.documentFormGroup.controls['quittanceImmob'].setValidators([]);
          this.documentFormGroup.controls['propertyTitle'].setValidators([]);
          this.documentFormGroup.controls['waterBill'].setValidators([]);
          this.documentFormGroup.controls['certImpos'].setValidators([]);
          this.documentFormGroup.controls['taxBill'].setValidators([]);
          this.documentFormGroup.controls['assuranceLogement'].setValidators([]);
          this.documentFormGroup.controls['letterSignedByHost'].setValidators([Validators.required]);
          this.documentFormGroup.controls['justificatifDomicileHost'].setValidators([Validators.required]);
          this.documentFormGroup.controls['justificatifDomicile'].setValidators([Validators.required]);
        } else {
          this.documentFormGroup.controls['letterSignedByHost'].setValidators([]);
          this.documentFormGroup.controls['justificatifDomicileHost'].setValidators([]);
          this.documentFormGroup.controls['justificatifDomicile'].setValidators([]);
          this.documentFormGroup.controls['phoneBill'].setValidators([]);
          this.documentFormGroup.controls['electroBill'].setValidators([]);
          this.documentFormGroup.controls['quittanceImmob'].setValidators([]);
          this.documentFormGroup.controls['propertyTitle'].setValidators([]);
          this.documentFormGroup.controls['waterBill'].setValidators([]);
          this.documentFormGroup.controls['certImpos'].setValidators([]);
          this.documentFormGroup.controls['taxBill'].setValidators([]);
          this.documentFormGroup.controls['assuranceLogement'].setValidators([]);
          const value = this.justificatifDomicile2.get('value')?.value;
          switch (value) {
            case 1:
              this.documentFormGroup.get('phoneBill')?.setValidators([
                Validators.required,
              ]);
              break;
            case 2:
              this.documentFormGroup.get('electroBill')?.setValidators([
                Validators.required,
              ]);
              break;
            case 3:
              this.documentFormGroup.get('quittanceImmob')?.setValidators([
                Validators.required,
              ]);
              break;
            case 4:
              this.documentFormGroup.get('propertyTitle')?.setValidators([
                Validators.required,
              ]);
              break;
            case 5:
              this.documentFormGroup.get('waterBill')?.setValidators([
                Validators.required,
              ]);
              break;
            case 6:
              this.documentFormGroup.get('certImpos')?.setValidators([
                Validators.required,
              ]);
              break;
            case 7:
              this.documentFormGroup.get('taxBill')?.setValidators([
                Validators.required,
              ]);
              break;
            case 8:
              this.documentFormGroup.get('assuranceLogement')?.setValidators([
                Validators.required,
              ]);
              break;
            default:
              this.documentFormGroup.get('phoneBill')?.setValidators([
                Validators.required,
              ]);
              break;
          }
          this.justificatifDomicile2.valueChanges.subscribe(({ value }) => {
          this.documentFormGroup.controls['phoneBill'].setValidators([]);
          this.documentFormGroup.controls['electroBill'].setValidators([]);
          this.documentFormGroup.controls['quittanceImmob'].setValidators([]);
          this.documentFormGroup.controls['propertyTitle'].setValidators([]);
          this.documentFormGroup.controls['waterBill'].setValidators([]);
          this.documentFormGroup.controls['certImpos'].setValidators([]);
          this.documentFormGroup.controls['taxBill'].setValidators([]);
          this.documentFormGroup.controls['assuranceLogement'].setValidators([]);
          switch (value) {
              case 1:
                this.documentFormGroup.controls['phoneBill'].setValidators([
                  Validators.required,
                ]);
                break;
              case 2:
                this.documentFormGroup.controls['electroBill'].setValidators([
                  Validators.required,
                ]);
                break;
              case 3:
                this.documentFormGroup.controls['quittanceImmob'].setValidators(
                  [Validators.required]
                );
                break;
              case 4:
                this.documentFormGroup.controls['propertyTitle'].setValidators([
                  Validators.required,
                ]);
                break;
              case 5:
                this.documentFormGroup.controls['waterBill'].setValidators([
                  Validators.required,
                ]);
                break;
              case 6:
                this.documentFormGroup.controls['certImpos'].setValidators([
                  Validators.required,
                ]);
                break;
              case 7:
                this.documentFormGroup.controls['taxBill'].setValidators([
                  Validators.required,
                ]);
                break;
              case 8:
                this.documentFormGroup.controls[
                  'assuranceLogement'
                ].setValidators([Validators.required]);
                break;
              default:
                this.documentFormGroup.controls['phoneBill'].setValidators([
                  Validators.required,
                ]);
                break;
            }
                this.documentFormGroup.controls['phoneBill'].updateValueAndValidity();
    this.documentFormGroup.controls['electroBill'].updateValueAndValidity();
    this.documentFormGroup.controls['quittanceImmob'].updateValueAndValidity();
    this.documentFormGroup.controls['propertyTitle'].updateValueAndValidity();
    this.documentFormGroup.controls['waterBill'].updateValueAndValidity();
    this.documentFormGroup.controls['certImpos'].updateValueAndValidity();
    this.documentFormGroup.controls['taxBill'].updateValueAndValidity();
    this.documentFormGroup.controls['letterSignedByHost'].updateValueAndValidity();
    this.documentFormGroup.controls['justificatifDomicileHost'].updateValueAndValidity();
    this.documentFormGroup.controls['justificatifDomicile'].updateValueAndValidity();
    this.documentFormGroup.controls['assuranceLogement'].updateValueAndValidity();
          });
        }
    this.documentFormGroup.controls['phoneBill'].updateValueAndValidity();
    this.documentFormGroup.controls['electroBill'].updateValueAndValidity();
    this.documentFormGroup.controls['quittanceImmob'].updateValueAndValidity();
    this.documentFormGroup.controls['propertyTitle'].updateValueAndValidity();
    this.documentFormGroup.controls['waterBill'].updateValueAndValidity();
    this.documentFormGroup.controls['certImpos'].updateValueAndValidity();
    this.documentFormGroup.controls['taxBill'].updateValueAndValidity();
    this.documentFormGroup.controls['letterSignedByHost'].updateValueAndValidity();
    this.documentFormGroup.controls['justificatifDomicileHost'].updateValueAndValidity();
    this.documentFormGroup.controls['justificatifDomicile'].updateValueAndValidity();
    this.documentFormGroup.controls['assuranceLogement'].updateValueAndValidity();
      });
    
      this.justificatifDomicile2.valueChanges.subscribe(({ value }) => {
          this.documentFormGroup.controls['phoneBill'].setValidators([]);
          this.documentFormGroup.controls['electroBill'].setValidators([]);
          this.documentFormGroup.controls['quittanceImmob'].setValidators([]);
          this.documentFormGroup.controls['propertyTitle'].setValidators([]);
          this.documentFormGroup.controls['waterBill'].setValidators([]);
          this.documentFormGroup.controls['certImpos'].setValidators([]);
          this.documentFormGroup.controls['taxBill'].setValidators([]);
          this.documentFormGroup.controls['assuranceLogement'].setValidators([]);
            switch (value) {
              case 1:
                this.documentFormGroup.controls['phoneBill'].setValidators([
                  Validators.required,
                ]);
                break;
              case 2:
                this.documentFormGroup.controls['electroBill'].setValidators([
                  Validators.required,
                ]);
              
                break;
              case 3:
                this.documentFormGroup.controls['quittanceImmob'].setValidators(
                  [Validators.required]
                );
                break;
              case 4:
                this.documentFormGroup.controls['propertyTitle'].setValidators([
                  Validators.required,
                ]);
                break;
              case 5:
                this.documentFormGroup.controls['waterBill'].setValidators([
                  Validators.required,
                ]);
                break;
              case 6:
                this.documentFormGroup.controls['certImpos'].setValidators([
                  Validators.required,
                ]);
                break;
              case 7:
                this.documentFormGroup.controls['taxBill'].setValidators([
                  Validators.required,
                ]);
                break;
              case 8:
                  this.documentFormGroup.controls[
                    'assuranceLogement'
                  ].setValidators([Validators.required]);
                break;
              default:
                this.documentFormGroup.controls['phoneBill'].setValidators([
                  Validators.required,
                ]);
                break;
            }
              this.documentFormGroup.controls['phoneBill'].updateValueAndValidity();
              this.documentFormGroup.controls['electroBill'].updateValueAndValidity();
              this.documentFormGroup.controls['taxBill'].updateValueAndValidity();
              this.documentFormGroup.controls['certImpos'].updateValueAndValidity();
              this.documentFormGroup.controls['waterBill'].updateValueAndValidity();
              this.documentFormGroup.controls['propertyTitle'].updateValueAndValidity();
              this.documentFormGroup.controls['assuranceLogement'].updateValueAndValidity();
              this.documentFormGroup.controls['quittanceImmob'].updateValueAndValidity();
        
      });
  }

  getImage(images: string[]) {
    if (images[0]) {
      this.image = images[0];
    }
  }
  getFile(files: any, label: string) {
    if (files) {
      this.file = [...this.file, , { label, ...files }];
    }
    this.file = this.file?.filter((el) => el);
    this.file.map((el) => {
      this.documentFormGroup.patchValue({ [el.label]: el[0] });
    });
  }
  deleteFile(index: number, label: string) {
    this.file = this.file.filter((el) => el.label != label);
    this.documentFormGroup.get(`${label}`)?.patchValue('');
  }
  getPosts() {
    this.missionApi
      .getAllPostes()
      .then((res: any) => {
        this.fonctionOptions = res;
      })
      .catch((err: any) => console.log(err));
  }
  getSecteur() {
    this.missionApi
      .getSecteurs()
      .then((res: any) => {
        this.domaineOptions = res;
      })
      .catch((err: any) => console.log(err));
  }
  submit() {
    if (this.isCondidat) {
      const graduationDateValue = this.form.get('graduationYear')?.value;
      if (graduationDateValue) {
      this.graduationYear = moment(graduationDateValue).format('YYYY-MM-DD');
      }
      const body = {
        civility: this.form.get('civility')?.value,
        contracttype: null,
        lastname: this.form.get('lastname')?.value,
        firstname: this.form.get('firstname')?.value,
        fullname:
          this.form.get('lastname')?.value +
          ' ' +
          this.form.get('firstname')?.value,
        birthDay: this.birthDay,
        graduationYear: this.graduationYear,
        ishandicap: this.form.get('ishandicap')?.value,
        handicapsituation: this.form.get('description')?.value,
        isliberal: false,
        mailadress: this.form.get('mailadress')?.value,
        numsiren: null,
        numrpps: null,
        numsiret: this.form.get('numsiret')?.value,
        socialKey: this.form.get('key')?.value,
        numsocialsecurity: this.form.get('numsocialsecurity')?.value,
        numtel: this.phoneForm.get('phone')?.value?.e164Number?.replace(/\s+/g, ''),
        typePosteId: this.form.get('fonction')?.value,
        typeSecteurId: this.form.get('worktype')?.value,
        adresseCandidatDto: {
          codePostale: this.form.get('postalcode')?.value,
          additionalAdress: this.form.get('adress')?.value,
          department: this.form.get('departmentName')?.value,
          regionName: this.form.get('regionName')?.value,
          regionCode: this.form.get('regionCode')?.value,
          pays: this.form.get('pays')?.value,
          lat: this.form.get('lat')?.value,
          lon: this.form.get('lon')?.value,
          ville: this.form.get('ville')?.value,
          note: this.form.get('note')?.value,
        },
        titleOfFirstDegree: 'BACHELOR',
        titleOfSecondDegree: 'LICENCE',
        titleOfThirdDegree: 'PHD',
        nationality: this.form.get('nationality')?.value,
        anotherNationality: 1,
        hostedByAnotherPerson: 2,
        iscin: null,
        ispassport: null,
      };
      this.condidatApi.upadateCandidat(body, this.user?.collary_id).subscribe({
        next: (res) => {
          this.flag.displayFlag(
            'Compte candidat crée avec succés !',
            FlagType.success
          );
          this.router.navigate(['login']);
          this.loading = false;
        },
        error: (err) => {
          this.flag.displayFlag(
            'Veuillez compléter les informations manquantes.',
            FlagType.error
          );
          this.loading = false;
        },
        complete: () => (this.loading = false),
      });
    } else {
      const body = {
        ...this.establishmentService.establishment,
        ...this.form.value,
      };
      this.establishmentService
        .updateEstablishment(body, this.establishmentService.establishment.id)
        .subscribe({
          next: (res: any) => {},
        });
    }
  }

  submitDocument() {
    this.user = localStorage.getItem('user')
      ? JSON.parse(localStorage.getItem('user') || '')
      : {};
    this.file.map((el) => {
      this.formData.append(el.label, el[0]);
    });
    this.condidatApi
      .uploadFileCandidat(this.formData, this.user?.collary_id)
      .subscribe({
        next: (res: any) => {
          this.file.map((el) => {
            this.formData.delete(el.label);
          });
          this.onSubmit.emit();
        },
        error: (err: any) => {
          this.file.map((el) => {
            this.formData.delete(el.label);
          });
        },
      });
  }
  // protected readonly domaineOptions = domaineOptions;
  protected readonly nationalityOptions = registerNationalityOptions;
}
